import { SVGIcon } from '@superops/super-icons';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getTranslatedText } from '@nile/components';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import {
  AccountClient,
  GET_RETAINER_CONTRACT_LIST,
  GET_CLIENT_USER_LIST
} from '@nile/graphql';
import { useLazyQuery, useQuery } from '@apollo/client';
import { reactSelectErrorStyles } from '@nile/banyan/src/Utils/style';

const ClientSection = (props) => {
  const {
    clients,
    intl,
    data,
    index,
    errors,
    addClientHandler,
    updateSharedClient,
    removeClientHandler,
    showContracts
  } = props;

  const [users, setUsers] = useState([]);

  const [fetchClientUsers] = useLazyQuery(GET_CLIENT_USER_LIST, {
    fetchPolicy: 'network-only',
    client: AccountClient,
    onCompleted: ({ getClientUserAssociationsList }) => {
      setUsers(
        getClientUserAssociationsList?.associations?.map((el) => {
          el = el.user;
          return {
            ...el,
            label: el.name,
            value: el.name
          };
        })
      );
    }
  });

  const { data: contractsData, loading: contractsLoading } = useQuery(
    GET_RETAINER_CONTRACT_LIST,
    {
      fetchPolicy: 'cache-and-network',
      client: AccountClient,
      skip: !data?.client || !showContracts,
      variables: {
        input: {
          client: { accountId: data?.client?.accountId }
        }
      },
      onCompleted: ({ getRetainerContractList }) => {
        if (!data?.contracts) {
          updateSharedClient(
            {
              ...data,
              contracts: getRetainerContractList?.map((el) => ({
                label: el.contractName,
                value: el.contractId
              }))
            },
            index
          );
        }
      }
    }
  );

  useEffect(() => {
    if (data?.client) {
      fetchClientUsers({
        variables: {
          input: {
            clientId: data.client?.accountId,
            listInfo: {
              sort: {
                attribute: 'user.name',
                order: 'ASC'
              }
            }
          }
        }
      });
    }
  }, [data]);

  return (
    <div className="flex visibilityContainer g10">
      <div className="flex f11 g10">
        <div className="flex actr w30 g10">
          <div className="fx actr">
            <SVGIcon name="ClientLogo" />
          </div>
          <div className="full-width">
            <Select
              classNamePrefix="value_selector"
              formatGroupLabel={formatGroupLabel}
              value={data?.client}
              components={{ IndicatorSeparator, DropdownIndicator }}
              title={getTranslatedText(intl, 'reports.report.share.client')}
              onChange={(val) => {
                updateSharedClient(
                  showContracts
                    ? { client: val, users: null, contracts: null }
                    : { client: val, users: null },
                  index
                );
              }}
              options={clients}
              placeholder={getTranslatedText(
                intl,
                'reports.report.share.pl.client'
              )}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              name="valueselector"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                ...(errors &&
                  errors[index] &&
                  errors[index].error &&
                  errors[index].error.client &&
                  errors[index].error.client[0] &&
                  reactSelectErrorStyles)
              }}
            />
          </div>
        </div>
        <div className="flex actr w70mx g10 w30mn">
          <div className="fx actr">
            <SVGIcon name="TechnicianGroup" />
          </div>
          <div className="full-width">
            <Select
              classNamePrefix="value_selector"
              formatGroupLabel={formatGroupLabel}
              value={data?.users}
              components={{ IndicatorSeparator, DropdownIndicator }}
              title={getTranslatedText(intl, 'reports.report.share.users')}
              onChange={(val) => {
                updateSharedClient(
                  showContracts
                    ? {
                        client: data?.client,
                        users: val,
                        contracts: data?.contracts
                      }
                    : { client: data?.client, users: val },
                  index
                );
              }}
              options={users}
              placeholder={getTranslatedText(
                intl,
                'reports.report.share.pl.users'
              )}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              name="valueselector"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                ...(errors &&
                  errors[index] &&
                  errors[index].error &&
                  errors[index].error.users &&
                  errors[index].error.users[0] &&
                  reactSelectErrorStyles)
              }}
              isMulti
            />
          </div>
        </div>
        {showContracts && (
          <div className="flex actr w70mx g10 w30mn">
            <div className="fx actr">
              <SVGIcon name="Contract" />
            </div>
            <div className="full-width">
              <Select
                classNamePrefix="value_selector"
                formatGroupLabel={formatGroupLabel}
                value={data?.contracts}
                components={{ IndicatorSeparator, DropdownIndicator }}
                title={getTranslatedText(intl, 'reports.report.share.users')}
                onChange={(val) => {
                  updateSharedClient(
                    {
                      ...data,
                      contracts: val
                    },
                    index
                  );
                }}
                options={
                  contractsData?.getRetainerContractList?.map(
                    (clientContract) => ({
                      label: clientContract.contractName,
                      value: clientContract.contractId
                    })
                  ) || []
                }
                placeholder={getTranslatedText(
                  intl,
                  'contractViews.navigation.header'
                )}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                closeMenuOnScroll={(e) => {
                  return (
                    e.target &&
                    e.target.classList &&
                    !(e.target.classList.value.indexOf('menu-list') > -1)
                  );
                }}
                name="valueselector"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 })
                }}
                isMulti
                isLoading={contractsLoading}
              />
            </div>
          </div>
        )}
      </div>
      {!showContracts && (
        <div className="flex actr g10">
          <div className="fx btn actr" onClick={addClientHandler}>
            <SVGIcon name="RuleAdd" color="#96DD4B" size="sm" />
          </div>
          <div
            className="fx btn actr"
            onClick={() => removeClientHandler(index)}
          >
            <SVGIcon name="RuleMinus" color="#FA3F3F" size="sm" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientSection;
